export enum AddCodeModalID {
    GENERAL,
    SCOPE_ASSIGNMENT
}

export enum CodeTypesValues {
    ACCOUNT_CODE = 0,
    AGENT_NA = 10
}

export enum CodeTypesStringValues {
    ACCOUNT_CODE = 'Account Code',
    AGENT_NA = 'Agent NA'
}

export enum StyleClassNames {
    ERROR = 'server-error',
    SUCCESS = 'server-success'
}
